import { Box, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

import useIsMobileSize from 'src/hooks/useIsMobileSize';
import Steps from 'src/widgets/Steps';
import { LayoutPaper, DesktopLayout } from 'src/layout';
import useUserStore from 'src/stores/user';
import useSessionStore from 'src/stores/session';
import useGoTo from 'src/hooks/useGoTo';
import { ROUTES_URL } from 'src/constants/routes';
import ConfettiAnimation from 'src/components/ConfettiAnimation';

export default function BeginWorkScreen() {
    const isMobile = useIsMobileSize();
    const isOnboardingCompleted = useUserStore(({ isOnboardingCompleted }) => isOnboardingCompleted);
    const { getUserSessionRequiredData, checkUserDataChanges, hasSessionSnapshot } = useSessionStore(
        ({ getUserSessionRequiredData, checkUserDataChanges, hasSessionSnapshot }) => ({
            getUserSessionRequiredData,
            checkUserDataChanges,
            hasSessionSnapshot,
        })
    );
    const goTo = useGoTo();
    const [isChecking, setIsChecking] = useState(true);
    const [showConfetti, setShowConfetti] = useState(false);
    const hasRequestedRef = useRef(false);

    useEffect(() => {
        if (hasRequestedRef.current) {
            return;
        }

        hasRequestedRef.current = true;
        console.log('🔄 [BeginWorkScreen] Загружаем сессию пользователя...');
        setIsChecking(true);
        const refreshSession = hasSessionSnapshot ? checkUserDataChanges() : getUserSessionRequiredData();

        refreshSession
            .then((data) => {
                console.log('✅ [BeginWorkScreen] Сессия обновлена:', {
                    has_changes: typeof data === 'boolean' ? data : undefined,
                    is_onboarding_completed:
                        typeof data === 'boolean' ? undefined : data?.user?.is_onboarding_completed,
                    onboarding_step: typeof data === 'boolean' ? undefined : data?.user?.onboarding_step,
                });
            })
            .catch((error) => {
                console.error('❌ [BeginWorkScreen] Ошибка загрузки данных:', error);
            })
            .finally(() => {
                setIsChecking(false);
            });
    }, [checkUserDataChanges, getUserSessionRequiredData, hasSessionSnapshot]);

    // Если онбординг завершен - показываем салют и перенаправляем на Feed
    useEffect(() => {
        console.log('🔍 [BeginWorkScreen] Проверка статуса:', { isChecking, isOnboardingCompleted });
        if (!isChecking && isOnboardingCompleted) {
            console.log('🎉 [BeginWorkScreen] Онбординг завершен, показываем салют и перенаправляем на /feed');
            setShowConfetti(true);

            // Останавливаем салют через 3 секунды и перенаправляем
            const timer = setTimeout(() => {
                setShowConfetti(false);
                window.location.href = `${ROUTES_URL.FEED}?onboarding_completed=true`;
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [isOnboardingCompleted, isChecking]);

    // Если данные еще загружаются - не показываем контент
    if (isChecking) {
        return null;
    }

    // Если онбординг завершен - показываем салют
    if (isOnboardingCompleted) {
        return (
            <>
                {showConfetti && (
                    <ConfettiAnimation
                        isPlaying={true}
                        loop={false}
                    />
                )}
            </>
        );
    }

    const renderContent = () => {
        return (
            <>
                <Box mb={20 / 8}>
                    <Typography
                        variant="h1"
                        color="text.primary"
                    >
                        Начало работы
                    </Typography>
                </Box>
                <Steps />
            </>
        );
    };

    if (!isMobile) return <DesktopLayout>{renderContent()}</DesktopLayout>;

    return <LayoutPaper isWhite>{renderContent()}</LayoutPaper>;
}
